import { useState } from 'react';
import { Compass, Wrench } from 'lucide-react';
import MyDomain from '../../components/learn/MyDomain';
import MyCraft from '../../components/learn/craft/MyCraft';

const TOP_TABS = [
  { id: 'domain' as const, label: 'My Domain', icon: Compass },
  { id: 'craft' as const, label: 'My Craft', icon: Wrench },
];

export default function Learn() {
  const [activeTab, setActiveTab] = useState<'domain' | 'craft'>('domain');

  return (
    <div className="app-page">
      <div className="mb-8 border-b border-app-line pb-6">
        <p className="app-kicker mb-2">Enablement</p>
        <h1 className="font-display text-3xl font-semibold text-app-ink sm:text-4xl">Learn</h1>
        <p className="mt-2 text-sm text-app-muted">Build domain expertise and repeatable sales craft.</p>
      </div>

      <div className="mb-8 flex gap-1 overflow-x-auto border-b border-app-line" role="tablist" aria-label="Learning areas">
        {TOP_TABS.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            role="tab"
            aria-selected={activeTab === tab.id}
            className={`flex items-center gap-2 px-5 py-3 text-sm font-medium border-b-2 -mb-px transition-colors ${
              activeTab === tab.id
                ? 'border-forest-600 text-forest-700'
                : 'border-transparent text-app-muted hover:text-app-ink hover:border-app-line-strong'
            }`}
          >
            <tab.icon className="w-4 h-4" />
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === 'domain' && <MyDomain />}

      {activeTab === 'craft' && <MyCraft />}
    </div>
  );
}
